import React from "react";
import Navigation from "./Navigation";
import PageTitle from "./PageTitle";
import SocialLinks from "./SocialLinks";

import { StaticImage } from "gatsby-plugin-image";

type FooterProps = {
  settings: Queries.SiteSettingsFragment | null;
  nav: Queries.SiteSettingsFragment["navigationItems"];
};

const Footer = (props: FooterProps) => {
  return (
    <div className="bg-c-footer-bg py-16 bg-[url('../images/line-building-stretched.webp')] bg-bottom bg-cover bg-no-repeat">
      <div className="container mx-auto px-5 text-white">
        <div className="flex flex-col gap-y-6 items-center">
          <PageTitle
            title={props.settings?.siteTitle ?? ""}
            className="text-c-footer-title text-3xl md:text-5xl lg:text-[60px]"
          />
          <div className="hidden md:block mb-3">
            <Navigation placement="Footer" src={props.nav} />
          </div>
          <SocialLinks />
          <div className="my-5 flex flex-col md:flex-row items-center gap-14 container">
            <div className="basis-1/2 text-right">
              <a href="http://www.rapatac.se" target="_blank" rel="nofollow">
                <StaticImage
                  className="max-h-20 ml-auto"
                  src="../../images/rapatac_logotype.png"
                  alt="Rapatac"
                  height={80}
                />
              </a>
            </div>
            <div className="basis-1/2">
              <a
                href="http://www.arvsfonden.se/"
                target="_blank"
                rel="nofollow"
              >
                <StaticImage
                  className="max-h-20 mr-auto"
                  src="../../images/arvsfonden.png"
                  alt="Arvsfonden"
                  height={80}
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
